import React from 'react';
import NotificationsActiveOutlinedIcon from '@mui/icons-material/NotificationsActiveOutlined';
import NotificationsOffOutlinedIcon from '@mui/icons-material/NotificationsOffOutlined';
import { useInterveneMessageSoundPreference } from '../hooks/useInterveneMessageSound';
import InterveneToolbarIconButton from './InterveneToolbarIconButton';

export default function MessageSoundToggle({ compact = false }) {
  const { soundsEnabled, toggleSoundsEnabled } = useInterveneMessageSoundPreference();
  const title = soundsEnabled ? 'Mute message sounds' : 'Unmute message sounds';

  return (
    <InterveneToolbarIconButton
      title={title}
      ariaLabel={title}
      ariaPressed={soundsEnabled}
      compact={compact}
      onClick={toggleSoundsEnabled}
      icon={
        soundsEnabled ? (
          <NotificationsActiveOutlinedIcon />
        ) : (
          <NotificationsOffOutlinedIcon />
        )
      }
    />
  );
}
